module.exports = __webpack_public_path__ + "img/nav-cleaning_journals.6ea54dd5.svg";